export const sortByDate = (a, b) => new Date(a) - new Date(b);

export const sortByAlphabetical = (a, b) => a?.localeCompare(b);
